import React from 'react';

// ---- Helpers ----
const StatusPill = ({ status }) => {
	const isSolved = status === 'SOLVED';
	const cls = isSolved ? 'bg-lightGreen text-textGreen' : 'bg-lightOrange text-textOrange';
	return (
		<span className={`px-3 py-2 inline-flex text-xs leading-5 font-semibold rounded-full ${cls}`}>
			{status}
		</span>
	);
};

const Actions = ({ onViewDetailsClick }) => (
    <div className="text-dark-blue text-20 leading-24 underline">
        <span className='cursor-pointer'
        onClick={onViewDetailsClick}>
            View details</span>
        
	</div>
);

const UserQueriesTable = ({ userQueries, onViewDetails }) => {
	const styles = {
		tableDiv: 'bg-white rounded-lg overflow-auto mb-14',
		topTableHead: 'px-4 py-4 text-lg leading-100 font-medium text-gray text-left',
		tableData: 'px-4 py-4 text-lg font-medium text-dark-blue leading-100 text-left'
	};

	return (
		<div className={styles.tableDiv}>
			<div className="w-full">
				<table className="min-w-[700px] xl:min-w-full">
					<thead className="bg-[#F2F3F7]">
						<tr>
							<th scope="col" className={styles.topTableHead}>
								QUERY ID
							</th>
							<th scope="col" className={styles.topTableHead}>
								EMAIL
							</th>
							<th scope="col" className={styles.topTableHead}>
								MESSAGE
							</th>
							<th scope="col" className={styles.topTableHead}>
								STATUS
							</th>
							<th scope="col" className={styles.topTableHead}>
								ACTIONS
							</th>
						</tr>
					</thead>

					<tbody className="bg-white">
						{userQueries.map((u) => (
							<tr key={u.query_id}>
								<td className={styles.tableData}>{u.query_id}</td>
								<td className={styles.tableData}>{u.email}</td>
								<td className={styles.tableData}>{u.message}</td>
								<td className="px-5 py-4 text-lg">
									<StatusPill status={u.status} />
								</td>
								<td className="px-5 py-4">
									<Actions
										onViewDetailsClick={() => onViewDetails(u)}
									/>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default UserQueriesTable;
